
function initTierQuantityInputs(root = document) {
  root.querySelectorAll('quantity-input').forEach(container => {
    const qtyInput = container.querySelector('.qty-input__input');
    const plusBtn = container.querySelector('.qty-input__btn[name="plus"]');
    const minusBtn = container.querySelector('.qty-input__btn[name="minus"]');
    if (!qtyInput || !plusBtn || !minusBtn) return;

    // Prevent re-init
    if (container.dataset.tierInit === "true") return;
    container.dataset.tierInit = "true";

    // Read tier data
    const tierData = container.dataset.tierSteps;
    const tierSteps = tierData
      ? tierData.split(',').map(v => parseInt(v.trim(), 10)).filter(Boolean)
      : [1];
    const maxQuantity = 50000;

    // Generate all valid quantity values
    function generateQuantities(tiers, maxQty = 50000) {
      const quantities = [];
      for (let i = 0; i < tiers.length; i++) {
        const step = tiers[i];
        const nextTier = tiers[i + 1] || maxQty + step;
        let value = step;
        while (value < nextTier && value <= maxQty) {
          if (!quantities.includes(value)) quantities.push(value);
          value += step;
        }
      }
      return quantities.sort((a, b) => a - b);
    }

    const validQuantities = generateQuantities(tierSteps);
    let currentValue = parseInt(qtyInput.value, 10) || validQuantities[0];
    let currentIndex = validQuantities.findIndex(v => v >= currentValue);
    if (currentIndex === -1) currentIndex = validQuantities.length - 1;
    qtyInput.value = validQuantities[currentIndex];

    // Debounced Shopify update trigger
    let debounceTimer;
    function updateShopify() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }, 400);
    }
 
    function moveValue(direction) {
      if (direction === "up" && currentIndex < validQuantities.length - 1) {
        currentIndex++;
      } else if (direction === "down" && currentIndex > 0) {
        currentIndex--;
      }
      qtyInput.value = validQuantities[currentIndex];
      updateShopify();
    }

    // Events
    plusBtn.addEventListener("click", e => { e.preventDefault(); moveValue("up"); });
    minusBtn.addEventListener("click", e => { e.preventDefault(); moveValue("down"); });

    qtyInput.addEventListener("keydown", e => {
      if (e.key === "ArrowUp") { e.preventDefault(); moveValue("up"); }
      if (e.key === "ArrowDown") { e.preventDefault(); moveValue("down"); }
    });

    qtyInput.addEventListener("keypress", e => e.preventDefault());
    qtyInput.addEventListener("wheel", e => e.preventDefault());
  });
}

// Initialize on first load
document.addEventListener("DOMContentLoaded", () => initTierQuantityInputs());

// Reinitialize when Shopify dynamically reloads a section (cart drawer or cart)
document.addEventListener("shopify:section:load", e => {
  initTierQuantityInputs(e.target);
});

// Observe cart DOM for dynamic replacements (cart page + drawer)
['cart-items', '#CartDrawer', '#cart-drawer-form'].forEach(sel => {
  const el = document.querySelector(sel);
  if (!el) return;
  const observer = new MutationObserver(() => initTierQuantityInputs(el));
  observer.observe(el, { childList: true, subtree: true });
});
